import type { Initiative } from '../../../../../api/initiative-client/initiative-client.type';
import { useTranslation } from 'react-i18next';
import { inkLight, secondaryBase } from '../../../../../styles/design-tokens';
import { Text } from '../../../../../ui-library/typography/typography';
import { FiltersList } from './filters-list';

type Props = {
  initiatives: Initiative[];
  selectedInitiatives: Initiative[];
  onSelectInitiatives: (initiatives: Initiative[]) => void;
};

export const FiltersListInitiatives = ({ initiatives, selectedInitiatives, onSelectInitiatives }: Props) => {
  const i18n = useTranslation();
  const getTasksDone = (initiative: Initiative) => {
    let tasksCompleted = 0;
    Object.values(initiative.contributing_teams_over_time || {}).forEach((team) => {
      Object.values(team.tasks || {}).forEach((count) => {
        tasksCompleted += count || 0;
      });
    });
    return tasksCompleted;
  };

  return (
    <FiltersList
      items={initiatives}
      selectedItems={selectedInitiatives}
      onSelectItems={onSelectInitiatives}
      getItemName={(initiative) => initiative.name}
      getItemLabel={(initiative) => (
        <>
          <Text size="small" color={secondaryBase} style={{ lineHeight: '20px' }}>
            {initiative.key}
          </Text>
        </>
      )}
      getItemDescription={(initiative) => (
        <Text size="small" style={{ lineHeight: '20px' }}>
          {initiative.name}
        </Text>
      )}
      getItemExtraInfo={(initiative) => {
        const tasksDone = getTasksDone(initiative);
        return (
          <Text size="small" color={inkLight}>
            {`${tasksDone} ${(tasksDone === 1 ? i18n.t('common.work_unit') : i18n.t('common.work_units')).toLowerCase()}`}
          </Text>
        );
      }}
    />
  );
};
